import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import * as Animate from "react-reveal";
import { useLocation } from "react-router-dom";
import EmptySchoolList from "../../components/blocks/EmptySchoolList";
import { scrollToTop } from "../../utils/scrollToTop";
import SchoolHeader from "../schools_payfi/components/SchoolHeader";
import SuccessStorySection from "./components/SuccessStorySection";
import { businessSchoolData } from "./components/businessSchoolData";
import { data as businessData } from "./components/data";
import SiteFooter from "../../components/layout/SiteFooter";

const Course = ({ type, title, description, url, courseToolsLearn }) => {
  return (
    <div className="mb-4 bg-white rounded flex flex-col justify-between">
      <div className="card z-10 technovation-item w-full text-default pt-8 pb-2 px-6 bg-white rounded ">
        <p className="text-sm mb-2 tracking-widest capitalize">{type}</p>

        <p className="font-medium font-mono text-base text-primary mb-5">
          {title}
        </p>

        <p className="text-gray text-sm leading-6">{description}</p>
      </div>

      <hr className="mx-6 border-gray-2 mt-3 mb-4" />

      <div className="px-6">
        <p className="text-sm mb-3 font-semibold">
          What your team will learn includes:
        </p>
        <ul className="text-sm px-3 text-gray list-outside list-disc space-y-3">
          {courseToolsLearn?.map((a, index) => (
            <li key={index}>{a}</li>
          ))}
        </ul>
      </div>

      <div className="bg-white px-6 pb-8 pt-4">
        <div className="relative ">
          <div className="block">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={url}
              className="text-sm text-center block font-medium hover:font-bold bg-secondary transition-all py-4 px-8 text-white rounded-xl focus:outline-none"
            >
              Speak to a consultant
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const Courses = () => {
  const location = useLocation();
  const [courseType, setCourseType] = useState("");
  const [courses, setCourses] = useState([]);
  const [school, setSchool] = useState({});

  useEffect(() => {
    scrollToTop();

    const extractType = location?.search?.replace("?type=", "");
    const decodeText = decodeURI(extractType);

    setCourseType(decodeText);
    setCourses(
      extractType
        ? businessData?.filter((a) => a?.type?.toLowerCase() === decodeText)
        : businessData
    );

    const selectedSchool = businessSchoolData?.find(
      (a) => a?.name?.toLowerCase() === decodeText
    );

    setSchool({
      ...selectedSchool,
      name: `Enterprise ${selectedSchool?.name || ""} School`,
    });
  }, [location]);

  return (
    <div>
      <Helmet>
        <title>
          {school?.seoTitle
            ? `${school.seoTitle} `
            : "Utiva | Business Courses"}
        </title>
        <meta name="description" content={school?.metatags} />
        <meta
          property="og:title"
          content={school?.seoTitle || "Utiva | Business Courses"}
        />
        <meta property="og:description" content={school?.metatags || ""} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
      </Helmet>

      <SchoolHeader
        selectedSchoolData={school}
        avatarText="Transform your business with Technology"
        hasButtonLink={true}
        buttonLinkTitle={"Download Brochure"}
        buttonLinkUrl={school?.brochureLink}
      />

      <section className="courses-available relative py-14">
        <div className="container px-4 mx-auto lg:pt-8">
          <Animate.Fade bottom>
            <h2 className="w-8/12 text-primary text-2xl md:text-3xl lg:text-4xl xl:text-4xl xl:leading-tight font-mono font-semibold capitalize">
              All {courseType} Courses
            </h2>

            <p className="mt-4 text-sm-15 lg:text-base xl:text-lg lg:leading-7 w-full">
              We are a platform that helps you learn tech skills and turn
              projects into hiring visibility.
            </p>
          </Animate.Fade>

          {courses?.length > 0 ? (
            <div className="relative pt-8 lg:pt-14 pb-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-10 z-10">
              {courses?.map((d) => (
                <Course
                  url={
                    "https://calendar.google.com/calendar/u/0/appointments/AcZssZ2VblXSK9CKWIQljqzSvIG985hIHf2g-O0g8x4=?gv=true"
                  }
                  type={d?.type}
                  title={d?.title}
                  description={d?.decription}
                  courseToolsLearn={d?.modules}
                />
              ))}
            </div>
          ) : (
            <EmptySchoolList />
          )}
        </div>
      </section>

      <SuccessStorySection />

      <SiteFooter />
    </div>
  );
};

export default Courses;
